import { useNavigate } from 'react-router-dom';
import * as Dialog from '@radix-ui/react-dialog';
import { type Dispatch, type SetStateAction } from 'react';

import Congratulations from 'assets/images/congratulations.png';
import Firecracker from 'assets/images/firecracker.png';
import useTargetStore from '@/store/target';

interface CongratulationsDialogPropsType {
  isOpenDialog: boolean;
  setIsOpenDialog: Dispatch<SetStateAction<boolean>>;
}

export default function CongratulationsDialog({ isOpenDialog, setIsOpenDialog }: CongratulationsDialogPropsType) {
  const { doneNotice, step } = useTargetStore();

  // const currentStep =
  //   step.find((step) => point >= step.start && point < step.end) ||
  //   steps[steps.length - 1];

  const navigate = useNavigate();

  return (
    <Dialog.Root open={isOpenDialog} onOpenChange={setIsOpenDialog}>
      <Dialog.Portal>
        {/* 백드롭 */}
        <Dialog.Overlay className="z-60 fixed inset-0 bg-black/80" />

        {/* 모달 본체 */}
        <Dialog.Content
          style={{
            boxShadow: '0px 10px 0px rgba(0, 0, 0, 0.3)',
          }}
          className="z-70 fixed left-1/2 top-1/2 w-[80%] max-w-[400px] -translate-x-1/2 -translate-y-1/2 rounded-3xl bg-white pb-[35px]"
        >
          <Dialog.Title className="relative mt-[18px]">
            <img src={Congratulations} className="scale-x-120" />
            <span
              style={{ textShadow: '0px 2px 0px rgba(0, 0, 0, 0.3)' }}
              className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[20px] font-black uppercase text-[#FEF3A0]"
            >
              Congratulations
            </span>
          </Dialog.Title>
          <Dialog.Description className="relative -translate-y-[10px] text-center text-[14px] font-[800] leading-[28px] text-[#391930]">
            <img src={Firecracker} className="w-full" />
            <span className="absolute bottom-0 left-1/2 w-full -translate-x-1/2 -translate-y-1/2">{doneNotice}</span>
          </Dialog.Description>

          <div className="flex items-center justify-center gap-[18px] px-[18px] text-white">
            <Dialog.Close asChild>
              <button
                className="flex-1 rounded-xl border-b-2 border-[#B9B9B9] bg-[#B9B9B9]"
                style={{ textShadow: '0px 2px 0px rgba(0, 0, 0, 0.3)' }}
              >
                <div className="rounded-xl border-2 border-[#292929] text-[18px] font-bold">CLOSE</div>
              </button>
            </Dialog.Close>
            <button
              onClick={() => navigate('/earn-more-points')}
              className="flex-1 rounded-xl border-b-2 border-[#B9B9B9] bg-[#FF4F95]"
              style={{ textShadow: '0px 2px 0px rgba(0, 0, 0, 0.3)' }}
            >
              <div className="rounded-xl border-2 border-[#292929] text-[18px] font-bold">EARNED</div>
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
